import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import Login from './Login';
import BrandPanel from './BrandPanel';

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <BrandPanel>
        <div className="brand-spinner" role="status" aria-label="Checking your session" />
        <p className="text-subtitle2 text-sm">Checking your session…</p>
      </BrandPanel>
    );
  }

  if (!isAuthenticated) {
    return <Login />;
  }

  return <>{children}</>;
};

export default ProtectedRoute;
